import React from 'react'
import Header from './Header';
import { useLocation } from 'react-router-dom';
import product1 from "../Assets/s-930.jpg";
import product2 from "../Assets/s-780.jpg";
import product3 from "../Assets/s-660.jpg";
import product4 from "../Assets/s-460.jpg";
import product5 from "../Assets/s-390.jpg";
import product6 from "../Assets/s-280.jpg";
import product7 from "../Assets/s-230.jpg";
import product8 from "../Assets/s-170.jpg";
import product9 from "../Assets/s-120.jpg";
import product10 from "../Assets/s-70.jpg";
import product11 from "../Assets/s-550.jpg";
import { Helmet } from 'react-helmet';

const Product9 = () => {
  return (
    <>
    <script type="application/ld+json">
    {`
    {
      "@context": "https://schema.org/",
      "@type": "Product",
      "name": "Steel Shots",
      "description": "Steel Shot, Size S-110 Used for surface preparation, cleaning, and shot peening in various industries. Conforms to SAE J827 spec, suitable for removing rust and scale",
      "image": "https://steelshot.in/static/media/s-120.1dd7394de2510479d17c.jpg",
      "brand": {
          "@type": "Brand",
          "name": "Steel Shots"
      }
  }`
    }
  </script>
  <Helmet>
    <title>Rotocast - Steel Shot, Size S-110</title>
    <meta name="description" content={`Steel Shot, Size S-110 Used for surface preparation, cleaning, and shot peening in various industries. Conforms to SAE J827 spec, suitable for removing rust and scale`} />

    <meta property="og:image" content='https://steelshot.in/static/media/s-120.1dd7394de2510479d17c.jpg' />
  </Helmet>

    <Header heading="Steel Shot, Size S-110" />

    <div className="productdetail">

        <img src={product9} alt="Steel Shot, Size S-110" title="Steel Shot, Size S-110" width="auto" height="auto"/>
        <p>Steel shots with a size designation of S-110 refer to a specific grade and particle size within the abrasive blasting industry. The S stands for steel, indicating the material composition, while the number 110 denotes the sieve mesh size. In this context, S-110 steel shots have a particle size distribution that corresponds to the 110 mesh size, indicating a finer and more uniform grain structure. This particular size is often utilized for applications where a smoother surface finish is desired, such as in industries like automotive manufacturing or aerospace. The S-110 steel shots are known for their efficiency in removing rust, scale, and other contaminants from surfaces, making them a popular choice for shot blasting operations aiming for precision and quality surface preparation. The controlled size and hardness of S-110 steel shots contribute to their effectiveness in achieving consistent results while minimizing abrasive wear and prolonging equipment life.
        </p>
      </div>
      <div className="moreproductdetail">
        <div className="ChemicalComposition">
          <h3>Chemical Composition</h3>
          <p>Carbon 0.85-1.20%, Silicon 0.45-1.50%, Manganese 0.35-1.20%, Phosphorus &lt;0.05%, Sulphur &lt;0.05%
          </p>

        </div>
        <div className="Hardness">
          <h3>Hardness</h3>
          <p>40-50 HRc. (Rockwell C), Custom hardness on request
          </p>
        </div>
        <div className="Microstructure">
          <h3>Microstructure</h3>
          <p>Uniform martensite, tempered to a degree consistent with the hardness range, with fine, well distributed carbides, if any.
          </p>
        </div>
      </div>
    </>
  )
}

export default Product9